import { useTranslations } from "../../i18n";
import { workerUrl } from "@/lib/b2";

interface TwintQrCodeProps {
  /** Cle du fichier B2 du QR code TWINT du studio */
  qrCodeKey: string;
  /** Classes de taille appliquees a l'image du QR code */
  imageClassName?: string;
}

/**
 * QR code TWINT du studio.
 *
 * Un QR TWINT ne contient PAS d'URL : son contenu est un jeton interne a TWINT
 * (de la forme "02:<hex>#<hex>#"). Il ne peut donc ni etre transforme en lien
 * cliquable, ni etre lu par l'appareil photo — il ne se scanne que depuis
 * l'application TWINT elle-meme.
 *
 * Consequence directe : il faut un SECOND appareil. La cliente ne peut pas
 * scanner un QR affiche sur l'ecran du telephone qui fait tourner TWINT. Le
 * texte qui accompagne l'image doit le dire, sinon elle reste bloquee sans
 * comprendre pourquoi.
 */
export default function TwintQrCode({
  qrCodeKey,
  imageClassName = "w-48 h-48 md:w-56 md:h-56",
}: TwintQrCodeProps) {
  const t = useTranslations("checkout");

  return (
    <div className="w-full flex flex-col items-center gap-2">
      <img
        src={workerUrl(qrCodeKey)}
        alt="TWINT QR code"
        className={`${imageClassName} object-contain bg-white rounded border p-2`}
      />
      <p className="text-xs text-gray-500 text-center">
        {t("twintScanHint") ||
          "Open the TWINT app and scan this code from another device"}
      </p>
    </div>
  );
}
